import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import Carousel from '@brainhubeu/react-carousel'
import TestimonialsCard from './components/TestimonialsCard'

const TestimonialsSection = ({
    testimonials = []
}) => {
    const [slidesPerPage, setSlidesPerPage] = useState(window.innerWidth >= 768 ? 2.2 : 1);

    useEffect(() => {
        window.addEventListener('resize', setCardsPerScreen);
        return () => window.removeEventListener('resize', setCardsPerScreen);
    }, []);

    const setCardsPerScreen = (event) => {
        let windowSize = window.innerWidth;
        if(windowSize <= 768) {
            setSlidesPerPage(1);
        } else {
            setSlidesPerPage(2.2);
        }
    };

    return (
        <section className="testimonials-section">
            <Container>
                <h2 className="section-title">Testimonials</h2>
                <Carousel
                    autoPlay={2000}
                    slidesPerPage={slidesPerPage}
                    infinite
                    arrows
                >
                    {testimonials.map(({ image, title, subtitle, text }) => (
                        <TestimonialsCard
                            key={title}
                            image={image}
                            title={title}
                            subtitle={subtitle}
                            text={text}
                        />
                    ))}
                </Carousel>
            </Container>
        </section>
    )
}

export default TestimonialsSection
